/**
 * Safely parses a JSON string and handles undefined or null values.
 * @param {string} jsonString - The JSON string to parse.
 * @returns {object|null} - The parsed JSON object, or null if the input is invalid.
 */
function safeJsonParse(jsonString) {
  try {
    if (jsonString === undefined || jsonString === null) {
      return {};
    }
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Failed to parse JSON:', error);
    return {};
  }
}

// Export the function for use in other modules
export { safeJsonParse };
